










import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

export enum LoadSnipperSizes {
    S,
    M,
    L
}

@Component
export default class VLoadSpinner extends Vue {
    @Prop({ type: String, default: 'Loading...' }) loadingText: string
    @Prop({ type: Boolean, default: false }) showText: boolean
    @Prop({ type: Boolean, default: false }) horizontal: boolean
}
